import React from 'react';
import { ThreeDotsLoader } from '@wix/wix-ui-tpa/cssVars';
import classes from './PlanStartDatePickerLoader.css';

// TODO: Make skeleton loader
export const PlanStartDatePickerLoader = () => (
  <div className={classes.loader}>
    <ThreeDotsLoader />
  </div>
);
